export const appBuildAssetsDir = "/resources/"

export const appHead = {"meta":[{"charset":"utf-8"},{"content":"initial-scale=1.0, maximum-scale=1, shrink-to-fit=no, width=device-width","name":"viewport"},{"content":"strict-origin-when-cross-origin","name":"referrer"}],"link":[{"rel":"preload","href":"/fonts/OpenSans-Light/OpenSans-Light.woff?eimgli","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/OpenSans-Regular/OpenSans-Regular.woff?eimgli","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/OpenSans-SemiBold/OpenSans-SemiBold.woff?eimgli","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/OpenSans-Bold/OpenSans-Bold.woff?eimgli","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/OpenSans-ExtraBold/OpenSans-ExtraBold.woff?eimgli","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/Roboto-Regular/Roboto-Regular.woff","as":"font","type":"font/woff"},{"rel":"preload","href":"/fonts/SF-Pro-Display-Semibold/SF-Pro-Display-Semibold.woff","as":"font","type":"font/woff"}],"style":[],"script":[],"noscript":[],"title":"https://amazon-freedom.vmedia.ca"}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000